export default "__VITE_IMAGE_ASSET__9c46f438__";